import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { FeatureFlagService } from '@/common/integrations/feature-flag/feature-flag.service';
import { StorageService } from '@/common/integrations/storage/storage.service';

export async function clearSessionData() {
  FeatureFlagService.cleanDefaultUser();
  AnalyticsService.logoutChatUser();
  await StorageService.clearTokens();
}
